import React, { useContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Context } from "../context/ProductsProvider";
import { useAuthContext } from "../context/AuthContext";
import Firestore from "../handlers/firestore";
import Storage from "../handlers/storage";
import { FaArrowLeft } from 'react-icons/fa';
import  "./Slider.css";

const { updateProduct } = Firestore;

const Preview = ({path}) => {
  return (
      path && (
      <div
          className="rounded p-1 m-5"
          style={{
          width: "300px",
          height: "300px",
          backgroundImage: `url(${path})`,
          backgroundSize: "cover",
          }}
      ></div>
      )
  );
};

function UpdateProductForm() {
  const { state, dispatch, read } = useContext(Context);
  const { currentUser } = useAuthContext();
  const location = useLocation();
  const navigate = useNavigate();
  const { inputs, items } = state;

  const { id: itemId } = location.state || {};

  const [successMessage, setSuccessMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const currentItem = items.find((item) => item.id === itemId);
    if (currentItem) {
      dispatch({ type: "updateInputs", payload: { value: currentItem } });
    }
  }, [dispatch, items, itemId]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    dispatch({
      type: "updateInputs",
      payload: {
        value: {
          ...inputs,
          [name]: value || "",
        },
      },
    });
  };

  const username = currentUser?.displayName?.split(" ").join("") || "";

  const handleOnSubmit = (e) => {
    e.preventDefault();

      // Client-side validation
    if (!inputs.title || !inputs.category || !inputs.price) {
      alert("Please fill out all required fields.");
      return;
    }

    if (isSubmitting) return; // Prevent multiple submissions
    setIsSubmitting(true); // Set submitting state to true
  
    updateProduct({ ...inputs, user: username.toLowerCase() }, "products", itemId)
      .then(() => {
        read();
        setSuccessMessage("Product updated successfully!");
        // Clear form inputs
        dispatch({ type: "resetInputs" });
        setIsSubmitting(false); // Reset submitting state
        // Reset success message after 3 seconds
        setTimeout(() => {
          setSuccessMessage(null);
        }, 3000);
      })
      .catch((error) => {
        console.error("Error updating product:", error);
        setSuccessMessage("Error updating product.");
        setIsSubmitting(false); // Reset submitting state
      });
  };

  return (
      <>
      <FaArrowLeft className="arrow_add" onClick={() => {navigate(-1)}} />
      {successMessage && (
        <div className="alert alert-success alert-dismissible fade show" role="alert">
          {successMessage}
          <button type="button" className="btn-close" aria-label="Close" onClick={() => setSuccessMessage(null)}></button>
        </div>
      )}
      <p className="display-6 text-center mb-3">Update Product</p>
      <div className="mb-5 d-flex align-items-center justify-content-center">
        <Preview path={inputs.path}/>
        <form
          className="mb-2"
          style={{ textAlign: "left" }}
          onSubmit={handleOnSubmit}
        >
        <div className="mb-3">
          <label htmlFor="title" className="form-label">
            Product Name
          </label>
          <input
            type="text"
            className="form-control"
            id="title"
            name="title"
            placeholder="Enter product name"
            value={inputs.title || ''}
            onChange={handleOnChange}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="category" className="form-label">
            Category
          </label>
          <select
            className="form-select"
            id="category"
            name="category"
            value={inputs.category || ''}
            onChange={handleOnChange}
          >
            <option value="">Select Category</option>
            <option value="Shoes">Shoes</option>
            <option value="Wallets">Wallets</option>
            <option value="Bags">Bags</option>
            <option value="Clothes">Clothes</option>
            <option value="Jewellery">Jewellery</option>
            <option value="Glasses">Glasses</option>
            <option value="Perfumes">Perfumes</option>
          </select>
        </div>
        <div className="mb-3">
          <label htmlFor="subcategory" className="form-label">
          Subcategory
          </label>
          <select
            className="form-select"
            id="subcategory"
            name="subcategory"
            value={inputs.subcategory || ''}
            onChange={handleOnChange}
          >
          <option value="">Select Subcategory</option>
          <optgroup label="Men shoes subcategory">
            <option value="loafers">Loafers</option>
            <option value="sneakers">Sneakers</option>
            <option value="slides">Slides</option>
            <option value="yeezys">Yeezys</option>
          </optgroup>
          <optgroup label="Men bags subcategory">
            <option value="messengers">Messengers</option>
            <option value="duffles">Duffles</option>
            <option value="back-packs">Back Packs</option>
            <option value="slings">Slings</option>
            <option value="satchels">Satchels</option>
            <option value="belt-bags">Belt Bags</option>
          </optgroup>
          <optgroup label="Women shoes subcategory">
            <option value="espadrilles">Espadrilles</option>
            <option value="sneakers">Sneakers</option>
            <option value="slides">Slides</option>
            <option value="heels">Heels</option>
            <option value="sandals">Sandals</option>
          </optgroup>
          <optgroup label="Women bags subcategory">
            <option value="totes">Totes</option>
            <option value="shoulder-cross-body">Shoulder/Cross-Body</option>
            <option value="mini-bags">Mini Bags</option>
            <option value="clutches">Clutches</option>
          </optgroup>
          <option value="no-subcategory">No Subcategory</option>
        </select>
        </div>
        <div className="mb-3">
          <label htmlFor="gender" className="form-label">
            Gender
          </label>
          <select
            className="form-select"
            id="gender"
            name="gender"
            value={inputs.gender || ''}
            onChange={handleOnChange}
          >
            <option value="">Select gender</option>
            <option value="Men">Men</option>
            <option value="Women">Women</option>
          </select>
        </div>
        <div className="mb-3">
          <label htmlFor="description" className="form-label">
            Description
          </label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            placeholder="Enter product description"
            value={inputs.description || ''}
            onChange={handleOnChange}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="price" className="form-label">
            Price
          </label>
          <input
            type="number"
            className="form-control"
            id="price"
            name="price"
            placeholder="Enter price"
            value={inputs.price || ''}
            onChange={handleOnChange}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="size" className="form-label">
            Size
          </label>
          <input
            type="text"
            className="form-control"
            id="size"
            name="size"
            placeholder="Enter size"
            value={inputs.size || ''}
            onChange={handleOnChange}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="quantity" className="form-label">
            Quantity
          </label>
          <input
            type="number"
            className="form-control"
            id="quantity"
            name="quantity"
            placeholder="Enter quantity"
            value={inputs.quantity || ''}
            onChange={handleOnChange}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="color" className="form-label">
            Color
          </label>
          <input
            type="text"
            className="form-control"
            id="color"
            name="color"
            placeholder="Enter color"
            value={inputs.color || ''}
            onChange={handleOnChange}
          />
        </div>
        <button
          type="submit"
          className="btn btn-success float-end"
          disabled={isSubmitting} // Disable button while submitting
        >
          {isSubmitting ? "Submitting..." : "Save and Upload"}
        </button>
      </form>
    </div>
    </>
  );
}

export default UpdateProductForm;